




































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../Streamax/fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarTimeHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  selectedItems: string[] = [];
  checkboxes: any[] = [false, false, false, false, false];
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraBasic'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getBasic() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.norm.value = parseInt(this.data['?column?'].SysNorm);
    this.formFields.recordMode.value = parseInt(
      this.data['?column?'].AutoCover
    );
    this.formFields.camType.value = parseInt(this.data['?column?'].CameraType);
    this.formFields.displayType.value = this.data['?column?'].DisplayType;
    this.formFields.layout.value = parseInt(this.data['?column?'].EncodeType);
    /* this.formFields.viewChn.value = this.data['?column?'].EncodeType; */
    this.formFields.ahdType.value = parseInt(this.data['?column?'].EncodeType);
    this.selectedItems = this.data['channels'];
    this.checkboxes = new Array(5).fill(false);
    this.selectedItems.forEach((item: string) => {
      const index = parseInt(item);
      this.checkboxes[index] = true;
    });
  }
  mounted() {
    this.getBasic();
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    norm: any;
    recordMode: any;
    camType: any;
    displayType: any;
    layout: any;
    viewChn: any;
    ahdType: any;
  } = {
    norm: {
      label: 'Norm',
      value: 0,
      items: [{ label: 'PAL', id: 0 }, { label: 'NTSC', id: 1 }],
    },
    recordMode: {
      label: 'Record Mode',
      value: 0,
      items: [
        { label: 'A', id: 0 },
        { label: 'AUTO', id: 1 },
        { label: 'B', id: 2 },
      ],
    },
    camType: {
      label: 'Cam Type',
      value: 0,
      items: [
        { label: '8X1080P', id: 0 },
        { label: '4X1080P', id: 1 },
        { label: '8X720P', id: 2 },
        { label: '8X1080N', id: 3 },
        { label: '4X1080P + 4XD1', id: 4 },
        { label: '4X720P + 4XD1', id: 5 },
        { label: '2X1080P + 6X720P', id: 6 },
        { label: '2X1080P + 4X720P', id: 7 },
        { label: '6X1080P + 6XD1', id: 8 },
        { label: '2X1080P', id: 9 },
        { label: '2X720P', id: 10 },
        { label: '4X1080N', id: 11 },
        { label: '4X720P', id: 12 },
        { label: '2X720P + 2XD1', id: 13 },
        { label: '4XD1', id: 14 },
        { label: '1X1080p + 1XD1', id: 15 },
        { label: '4XD1 + 4X720P', id: 16 },
        { label: '4XD1 + 2X1080N', id: 17 },
        { label: '2X1080P + 2X720P', id: 18 },
        { label: '2X1080P + 2XD1', id: 19 },
        { label: '6X720P + 2XD1', id: 20 },
        { label: '2X720P + 6XD1', id: 21 },
        { label: '8X960H', id: 22 },
        { label: '4X960H', id: 23 },
        { label: '6X1080P + 2X960H', id: 24 },
        { label: '4XD1 + 2X1080P', id: 25 },
      ],
    },
    displayType: {
      label: 'Display Type',
      value: 0,
      items: [
        { label: '720x576', id: 0 },
        { label: '1024x768', id: 1 },
        { label: '1280x720', id: 2 },
        { label: '1920x1080', id: 3 },
        { label: 'Maximize', id: 4 },
      ],
    },
    layout: {
      label: 'Layout',
      value: 0,
      items: [{ label: 'Mode 1', id: 0 }, { label: 'NO', id: 1 }],
      //preguntar por este
    },
    viewChn: {
      label: 'view Chn',
      value: '',
      check: true,
    },
    ahdType: {
      label: 'AHD Type',
      value: 0,
      items: [{ label: 'H264', id: 0 }, { label: 'H265', id: 1 }],
    },
  };
  selectedNorm() {
    return this.formFields.norm.items.find(
      (item: { id: any }) => item.id === this.formFields.norm.value
    );
  }
  selectedRecordMode() {
    return this.formFields.recordMode.items.find(
      (item: { id: any }) => item.id === this.formFields.recordMode.value
    );
  }
  selectedCamType() {
    return this.formFields.camType.items.find(
      (item: { id: any }) => item.id === this.formFields.camType.value
    );
  }
  selectedDisplayType() {
    return this.formFields.displayType.items.find(
      (item: { id: any }) => item.id === this.formFields.displayType.value
    );
  }
  selectedLayout() {
    return this.formFields.layout.items.find(
      (item: { id: any }) => item.id === this.formFields.layout.value
    );
  }
  selectedAhdType() {
    return this.formFields.ahdType.items.find(
      (item: { id: any }) => item.id === this.formFields.ahdType.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }
  datoEditado: any = {};
  grabarEdicion(val: boolean) {
    if (val) {
      const check: String[] = [];
      this.checkboxes.forEach((item, index) => {
        if (item) check.push(index.toString());
      });
      this.datoEditado.channels = check;
      if (!this.datoEditado.channels.length) {
        this.$snotify.error('Debe estar seleccionado minimo 1 canal ', {
          timeout: 3000,
        });
        this.confirmCallbackConfirm(false);
        return;
      }
      console.log(this.datoEditado.channels);
      this.editar();
    }
    this.confirmCallbackConfirm(false);
  }
  async editar() {
    let self = this;
    return fetchConfiguracionStreamax(
      {
        channels: JSON.stringify(this.datoEditado.channels),
        id_camara: this.selectedValue,
        usuario: this.usuario,
      },
      'configCamaras/saveConfChannels'
    )
      .then((data: any) => {
        //console.log(data.data);
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualizacion exitosa', { timeout: 3000 });
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
    /* .finally(() => {
                return null;
              }); */
  }
  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }
  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
  confirmCallback(val: any) {}
  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = val;
  }
}
